import {HttpErrorResponse} from "@angular/common/http";
import {Observable, throwError} from "rxjs";
import {InfrastructureError, InfrastructureErrorType} from "@app/core/shared/domain/infrastructure.error";
import {AuthorizationError} from "@app/core/shared/domain/authoritzation.error";
import {ApiError, ApiErrorCode} from "@app/core/shared/domain/api.error";


function mapApiErrorCode(code: string): string | ApiErrorCode {
    const COUPON_ALREADY_USED = '400_0046';
    if (code === COUPON_ALREADY_USED) {
        return ApiErrorCode.COUPON_ALREADY_USED
    } else {
        return code
    }
}

export class BaseHandleErrorMapper {
    public static handleError(errorResponse: HttpErrorResponse): Observable<never> {
        let err
        let error = errorResponse.error

        let apiError: ApiError | undefined
        if (error?.error_message != null) {
            apiError = { code: mapApiErrorCode(error.error_code), message: error.error_message, status: error.error_status, extraInfo: error.extra_info } as ApiError
        }

        switch (errorResponse.status) {
            case 401:
                console.debug('Unauthorized');
                err = new AuthorizationError(error, errorResponse.message, apiError);
                break;

            case 406:
                console.debug('Not Acceptable');
                err = new InfrastructureError(InfrastructureErrorType.BackendError, error, errorResponse.message, apiError);
                break;

            case 500:
                console.debug('internalServer');
                err = new InfrastructureError(InfrastructureErrorType.InternalServerError, error, errorResponse.message);
                break;
            case 405:
            case 503:
                console.debug('Service Unavailable');
                err = new InfrastructureError(InfrastructureErrorType.ServiceUnavailableError, error, errorResponse.message);
                break;

            case 504:
                console.debug('timeout');
                err = new InfrastructureError(InfrastructureErrorType.TimeOutError, error, errorResponse.message);
                break;

            case 0:
                const isOnline = window.navigator.onLine;
                if (isOnline) {
                    err = new InfrastructureError(InfrastructureErrorType.ServiceUnavailableError, error, errorResponse.message);
                } else {
                    err = new InfrastructureError(InfrastructureErrorType.ConnectionError, error, errorResponse.message);
                }
                break;

            default:
                console.debug('resonseerror');
                err = new InfrastructureError(InfrastructureErrorType.BackendError, error, errorResponse.message, apiError);
        }

        return throwError(() => err);
    }
}
